var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "wall-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [_vm._v("Стены")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-step-two-img-container" }, [
        _c("img", {
          staticClass: "sidebar-step-two-img",
          attrs: { src: _vm.urlForStatic("/img/wall_outline.svg") }
        })
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("Обведите контуром плоскость "),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("стены")]),
      _vm._v(
        ", поочерёдно расставляя точки, соответствующие углам плоскости на изображении в рабочей области. Плоскость будет считаться завершенной, если замкнуть контур."
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }